import { lazy } from 'react';

const manifest = {
	AgGrid: lazy(() => import('./AgGrid')),
};

export default manifest;
